import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';

import componentStyles from './pc-color.css.lit';
import '../pc-heading/pc-heading';

/**
 * Color component
 * @element pc-color
 * @slot - This element has a default slot
 */
@customElement('pc-color')
export class PCColor extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  @property()
  color: string;

  render(): TemplateResult {
    const colorClasses = {
      color: true,
    };

    return html`
      <div class=${classMap(colorClasses)}>
        <div class="palette" style="background: var(${this.color})"></div>
        <div class="content">
          <slot></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-color': PCColor;
  }
}
